// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"294":"3a07577f","492":"29e033c9"}[chunkId] + ".chunk.js";
};